/**
 * Created by PuTi(编程即菩提) 2/19/17.
 * view
 */
var list = require('./view/list');
var bind = require('./bind');

var defaultChangeEvent = 'change keyup';

var propMap = {
    readonly: true,
    disabled: true,
    checked: true
};

module.exports = function (inNB) {
    var opts = inNB.opts;
    var $ = opts.$;
    var seq = 1;
    var document = opts.document;
    var addBind = function (inNBView, inBind) {
        var bindMappingList = inNBView.__nb_binding_list = inNBView.__nb_binding_list || [];
        var type = inBind.type;
        var target = inBind.target;
        var fn;
        switch (type) {
            case 'html':
                fn = function (inEvent) {
                    target.html(inEvent.data||'');
                };
                break;
            case 'text':
                fn = function (inEvent) {
                    target.text(inEvent.data||'');
                };
                break;
            case 'model':
                fn = function (inEvent) {
                    var model = inEvent.data;
                    target.setModel(model);
                };
                break;
            case 'attr':
                fn = function (inEvent) {
                    //target.attr(inBind.attr, inEvent.data);
                    var data = inEvent.data;
                    var attr = inBind.attr;
                    if (propMap[attr]) {
                        target.prop(attr, data);
                    } else if (inBind.attr == 'value') {
                        target.val(data);
                    } else {
                        target.attr(attr, data);
                    }
                };
                break;
            case 'class':
                fn = function (inEvent) {
                    var origin = inEvent.origin;
                    var data = inEvent.data;
                    var strValue = (data == undefined || data == null) ? '' : '' + data;
                    target.removeClass(origin || '');
                    target.addClass(strValue);
                };
                break;
            case 'style':
                fn = function (inEvent) {
                    var data = inEvent.data;
                    var value = (data == undefined || data == null) ? '' : data;
                    target.css(inBind.attr, value);
                };
                break;
        }
        inBind.fn = fn;
        bindMappingList.push(inBind);
    };

    var bindCls = function (inCls, in$El, inNBView) {
        if (!inCls) {
            return;
        }
        if (typeof  inCls === 'string') {
            in$El.addClass(inCls);
        } else if ($.isArray(inCls)) {
            $.each(inCls, function (inIndex, inCls) {
                if (typeof inCls === 'string') {
                    in$El.addClass(inCls);
                } else if (inCls instanceof inNB.Bind) {
                    addBind(inNBView, {
                        path: inCls.name,
                        target: in$El,
                        type: 'class'
                    });
                }
            });
        } else if (inCls instanceof inNB.Bind) {
            addBind(inNBView, {
                path: inCls.name,
                target: in$El,
                type: 'class'
            });
        }
    };
    var propertyParserMap = {
        $slot: function (inName, inValue, inNBView, in$El, inRoot, inIsBind) {
            var parent = inNBView.parent;
            var parentSlot = parent ? parent.prototype.slot : null;
            var currentSlot = inNBView.slot;
            var slotMap;
            if (parentSlot) {
                slotMap = {};
                $.each(parentSlot, function (inName, inSlot) {
                    slotMap[inName] = inSlot;
                });
                if(currentSlot){
                    $.each(currentSlot,function(inName,inSlot){
                       slotMap[inName] = inSlot;
                    });
                }
            } else {
                slotMap = currentSlot;
            }
            var slot;
            if (!slotMap) {
                return;
            }
            slot = slotMap[inValue];
            if (!slot) {
                return;
            }
            var name = '$' + slot[0];
            propertyParserMap[name](name, slot[1], inNBView, in$El, inRoot);
        },
        $html: function (inName, inValue, inNBView, in$El, inRoot, inIsBind) {
            if (inIsBind) {
                addBind(inNBView, {
                    path: inValue.name,
                    target: in$El,
                    type: 'html'
                });
            } else {
                parse(inValue, inNBView, in$El, inRoot);
            }
        },
        $text: function (inName, inValue, inNBView, in$El, inRoot, inIsBind) {
            if (inIsBind || (inValue && inValue instanceof inNB.Bind)) {
                addBind(inNBView, {
                    path: inValue.name,
                    target: in$El,
                    type: 'text'
                });
            } else if (!opts.mixRender) {
                in$El.text(inValue);
            }
        },
        'class': function (inName, inValue, inNBView, in$El, inRoot, inIsBind) {
            var cls = inValue;
            bindCls(cls, in$El, inNBView);
        },
        'style': function (inName, inValue, inNBView, in$El, inRoot, inIsBind) {
            var style = inValue;
            if (typeof style === 'string') {
                //TODO Maybe support
            } else {
                $.each(style, function (inName, inStyle) {
                    if (inStyle instanceof inNB.Bind) {
                        addBind(inNBView, {
                            path: inStyle.name,
                            target: in$El,
                            attr: inName,
                            type: 'style'
                        });
                    } else {
                        in$El.css(inName, inStyle);
                    }
                });
            }
        }
    };

    function parseProperty(inDef, inNBView, in$Parent, in$El, inRoot) {
        $.each(inDef, function (inName, inValue) {
            var parser = propertyParserMap[inName];
            var isBind = inValue instanceof inNB.Bind;
            var name = inName.toLowerCase();
            if (name === 'tag') {
                return;
            }
            if (parser) {
                parser(name, inValue, inNBView, in$El, inRoot, isBind);
            } else {
                if (isBind) {
                    addBind(inNBView, {
                        path: inValue.name,
                        target: in$El,
                        attr: name,
                        type: 'attr',
                        opts: inValue.opts
                    });
                } else {
                    if (name.indexOf('$') === 0) {
                        return;
                    }
                    in$El.attr(name, inValue);
                }
            }
        });
    }

    function createEl(inDef, inNBView, in$Parent, in$El, inRoot) {
        var tag = inDef.tag || 'div';
        var $el;
        var isMix = opts.mixRender;
        if (isMix) {
            //TODO array or json
            $el = in$El || in$Parent.children().eq(0);
        } else {
            //$el = $(['<', tag, '>'].join(''));
            $el = $(document.createElement(tag));
        }
        parseProperty(inDef, inNBView, in$Parent, $el, inRoot);
        if (in$Parent && !isMix) {
            in$Parent.append($el);
        }
        return $el;
    }

    function createType(inDef, inNBView, inParent, in$El, inRoot) {
        var type = inDef.$type;
        var component = new type(inParent, in$El);
        var modelPath = inDef.$model;
        var $component = component.$();
        var cls = inDef['class'];
        var style = inDef.style;
        component.setOpts(inDef.$opts);
        bindCls(cls, $component, inNBView);
        if (style) {
            $.each(style, function (inName, inStyle) {
                if (inStyle instanceof inNB.Bind) {
                    addBind(inNBView, {
                        path: inStyle.name,
                        target: $component,
                        attr: inName,
                        type: 'style'
                    });
                } else {
                    $component.css(inName, inStyle);
                }
            });
            //$component.css(style);
        }
        //TODO support '' path ?
        //if(modelPath == ''){
        //    debugger
        //}
        if (modelPath != undefined) {
            //addBind(inNBView || inRoot, {
            addBind(inNBView, {
                path: modelPath,
                target: component,
                type: 'model'
            });
        }
        if (inParent && !opts.mixRender) {
            inParent.append($component);
        }
        return component;
    }

    function parseObject(inDef, inNBView, inParent, in$El, inRoot) {
        var type = inDef.$type;
        var view;
        var $name = inDef.$name;
        var elMap;

        if (type) {
            view = createType(inDef, inNBView, inParent, in$El, inRoot);
        } else {
            view = createEl(inDef, inNBView, inParent, in$El, inRoot);
        }
        if ($name) {
            elMap = inNBView.__nb_elMap = inNBView.__nb_elMap || {};
            elMap[$name] = view
        }
        return view;
    }

    function parseArray(inDef, inNBView, inParent, in$El, inRoot) {
        var array = [];
        var isMix = opts.mixRender;
        var $el;
        $.each(inDef, function (inIndex, inItem) {
            var result;
            if (isMix) {
                if (inParent) {
                    $el = inParent.children().eq(inIndex);
                } else {
                    $el = $('#' + opts.rootElementIdPrefix + inIndex);
                }
            }
            result = parse(inItem, inNBView, inParent, $el, inRoot);
            array.push(to$el(result));
        });
        return array;
    }

    function parse(inDef, inNBView, inParent, in$El, inRoot) {
        var def = inDef || {};
        var defType = $.type(def);
        var $el = in$El;
        if (defType == 'array') {
            return parseArray(def, inNBView, inParent, $el, inRoot);
        } else if (defType == 'object') {
            if (opts.mixRender && !inParent) {
                $el = $('#' + opts.rootElementIdPrefix + 0);
            }
            return parseObject(def, inNBView, inParent, $el, inRoot);
        } else if (defType == 'string') {
            if (inParent && !opts.mixRender) {
                inParent.append(def);
            }
        }
    }

    function to$el(inEl) {
        var el = inEl;
        var array;
        if ($.isArray(el)) {
            array = [];
            $.each(el, function (inIndex, inEl) {
                array[inIndex] = to$el(inEl);
            });
            el = array;
        } else {
            if (el instanceof inNB.NBType) {
                el = el.__nb_elRoot
            }
        }
        return el;
    }

    inNB.View = inNB.extend(inNB.NBType, {
        method: {
            init: function (inParent, in$El) {
                var $el = parse(this.view, this, inParent, in$El);
                var model = this.model;
                this.__nb_instanceId = seq++;
                this.__nb_elRoot = $el;
                if (model) {
                    this.setModel(new model());
                }
            },
            $: function (inName) {
                var elMap = this.__nb_elMap = this.__nb_elMap || {};
                var el = this.__nb_elRoot;
                if (inName === true) {
                    el = to$el(el);
                } else if (inName) {
                    return elMap[inName];
                }
                return el;
            },
            setOpts: function (inOpts) {
                this.__nb_view_opts = inOpts;
            },
            getOpts: function (inOpts) {
                return this.__nb_view_opts;
            },
            getModel: function () {
                return this.__nb_model;
            },
            setModel: function (inModel) {
                var model = this.__nb_model;
                var bindingList = this.__nb_binding_list;
                if (bindingList) {
                    $.each(bindingList, function (inIndex, inBinding) {
                        var path = inBinding.path;
                        var attr = inBinding.attr;
                        var target = inBinding.target;
                        var bindingOpts = inBinding.opts;
                        var event = bindingOpts ? (bindingOpts.event || defaultChangeEvent ) : defaultChangeEvent;
                        if (model) {
                            model.offChange(inBinding.id);
                        }
                        if (inModel) {
                            if (inModel instanceof inNB.Model) {
                                if (path) {
                                    inBinding.id = inModel.onChange(path, inBinding.fn, inBinding.scope);
                                    inBinding.model = inModel;
                                    if (attr == 'value' && (target.prop("tagName") === 'INPUT' || target.prop("tagName") === 'TEXTAREA')) {
                                        if (!inBinding.domEvent) {
                                            inBinding.domEvent = function (inEvent) {
                                                var data = target.prop(attr);
                                                var model = inBinding.model;
                                                model.set(path, data);
                                            };
                                            target.on(event, inBinding.domEvent);
                                        }
                                    }
                                } else {
                                    inBinding.fn.call(inBinding.scope, {data: inModel, origin: model});
                                }
                            } else {
                                //something wrong,maybe use List Model but not implement from nb.model.List
                                debugger
                            }
                        }
                    });
                }
                this.__nb_model = inModel;
                this.onModelReady(inModel);
            },
            onModelReady: function (inModel) {

            }
        }
    });
    bind(inNB);
    list(inNB);
};


//////////////////
// WEBPACK FOOTER
// ../src/nb/core/js/core/view.js
// module id = 208
// module chunks = 35